import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-step-two-two',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './step-two-two.component.html',
  styleUrls: ['./step-two-two.component.scss']
})
export class StepTwoTwoComponent {
  @Input() userName: string = '';
} 